<template>
  <div class="modal-background">
    <div class="l-login-popin animated go fadeInRight in">
      <div class="l-login-popin-container float-center">
        <div class="text--right">
          <div class="l-login-popin__close-button" @click="closeLogin">
            <button
              class="c-button c-button--rounded l-login-popin__close-toggler c-button--close"
              type="button"
            >
              <i class="iconfont">&#xe615;</i>
            </button>
          </div>
        </div>
        <div class="l-login-popin__heading">
          <h2>登录</h2>
        </div>
        <div class="l-login-popin__item-separator">
          <div class="swiper-tab">
            <div
              :class="[currentTab == index ? 'active' : '', 'swiper-tab-list']"
              @click="tapNav(index)"
              v-for="(item, index) in swiperList"
              :key="index"
            >{{ item }}</div>
          </div>
          <!-- 验证码登录 -->
          <div v-if="currentTab == 0">
            <VForm :model="ValidateForm" :rule="rule" ref="baseForm">
              <FormItem prop="phone">
                <input
                  :class="[
                    loginError ? 'c-input-error' : '',
                    'c-input',
                    'c-input--fullwidth',
                  ]"
                  placeholder="手机号码" maxlength="11"
                  v-model="ValidateForm.phone"
                  @input="clearError('loginError', 'errMsg')"
                />
                <div class="error-msg" v-if="loginError">{{ errMsg }}</div>
              </FormItem>
              <FormItem prop="picCode" v-if="showPicCode">
                <div style="position: relative;">
                  <input
                    :class="[
                      capthaError ? 'c-input-error' : '',
                      'c-input',
                      'c-input--fullwidth',
                    ]"
                    v-model="ValidateForm.picCode"
                    placeholder="图形验证码" maxlength="5"
                    @blur="checkCaptha()"
                    @input="clearError('capthaError', 'capthaErrMsg')"
                  />
                  <img class="pic-code" :src="captchaImg" alt @click="getCaptcha" />
                </div>
                <div class="error-msg" v-if="capthaError">{{ capthaErrMsg }}</div>
              </FormItem>
              <FormItem prop="phoneCode">
                <div style="position: relative;">
                  <input
                    type="text"
                    :class="[
                      phonecodeError ? 'c-input-error' : '',
                      'c-input',
                      'c-input--fullwidth',
                    ]"
                    placeholder="手机验证码" maxlength="6"
                    v-model="ValidateForm.phoneCode"
                    @input="clearError('phonecodeError', 'phonecodeMsg')"
                  />
                  <button
                    class="send-code"
                    @click="sendMsg"
                    :disabled="disabledSendSMS"
                  >发送验证码{{ `${countdown ? "(" + countdown + "s)" : ""}` }}</button>
                </div>
                <div class="error-msg" v-if="phonecodeError">{{ phonecodeMsg }}</div>
              </FormItem>
            </VForm>
          </div>
          <!-- 密码登录 -->
          <div v-if="currentTab == 1">
            <VForm :model="ValidateForm" :rule="rule" ref="baseForm" class="c-form">
              <FormItem prop="account">
                <input
                  :class="[
                    accountError ? 'c-input-error' : '',
                    'c-input',
                    'c-input--fullwidth',
                  ]"
                  placeholder="邮箱/手机号码"
                  v-model="ValidateForm.account"
                  @input="clearError('accountError', 'accountMsg')"
                />
                <div class="error-msg" v-if="accountError">{{ accountMsg }}</div>
              </FormItem>
              <FormItem prop="password">
                <div style="position: relative;">
                  <input
                    :type="iptType"
                    :readonly="iptType == 'text'"
                    :class="[
                      passwordError ? 'c-input-error' : '',
                      'c-input',
                      'c-input--fullwidth',
                    ]"
                    placeholder="密码"
                    v-model="ValidateForm.password"
                    @input="clearError('passwordError', 'passwordMsg')"
                  />
                  <template v-if="isMobile">
                    <button
                      class="eye-icon__container"
                      @touchstart="toggleIptType"
                      @touchend="toggleIptType"
                    >
                      <i class="iconfont">&#xe608;</i>
                    </button>
                  </template>
                  <template v-else>
                    <button
                      class="eye-icon__container"
                      @mousedown="toggleIptType"
                      @mouseup="toggleIptType"
                    >
                      <i class="iconfont">&#xe608;</i>
                    </button>
                  </template>
                </div>
                <div class="error-msg" v-if="passwordError">{{ passwordMsg }}</div>
              </FormItem>
              <!-- <FormItem prop="picCode" v-if="showPicCode">
                <div style="position: relative;">
                  <input
                    :class="[
                      codeError ? 'c-input-error' : '',
                      'c-input',
                      'c-input--fullwidth',
                    ]"
                    v-model="ValidateForm.picCode"
                    placeholder="图形验证码"
                    @blur="checkCaptha()"
                  />
                  <img class="pic-code" :src="captchaImg" alt @click="getCaptcha" />
                </div>
                <div class="error-msg" v-if="codeError">{{ codeMsg }}</div>
              </FormItem> -->
            </VForm>
            <div class="form-group">
              <div class="ms-row">
                <div class="col-xs-6">
                  <div class="custom-checkbox">
                    <span class="clickable" @click="userCheck = !userCheck">
                      <i class="iconfont">
                        {{
                        userCheck ? "&#xedaf;" : "&#xec58;"
                        }}
                      </i>记住账号
                    </span>
                  </div>
                </div>
                <div class="col-xs-6 end-xs" @click="showForget = true">
                  <a class="reset-password" data-disable-context-menu>忘记密码&nbsp;?</a>
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="ms-row collapsed">
              <div class="col-xs-9 union-login">
                <template v-if="false">
                  <span class="union-login__hits">使用第三方账号登录</span>
                  <i class="iconfont login-icon" @click="toThridLogin('wechat')">&#xe624;</i>
                  <!-- <i class="iconfont login-icon">&#xe625;</i> -->
                  <i class="iconfont login-icon" @click="toThridLogin('alipay')">&#xe626;</i>
                  <!-- <i class="iconfont login-icon">&#xe662;</i> -->
                </template>
              </div>
              <div class="col-xs-3 end-xs login-btn">
                <input
                  type="button"
                  class="c-button c-button--primary c-button-login"
                  :disabled="disabledSubmit"
                  value="登录"
                  @click="submit"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="l-login-popin__new-account l-login-popin__item-separator">
          <div class="c-form__heading heading-h5 text--uppercase">创建账户</div>
          <p class="l-login-popin__text text--no-margin">通过手机号码创建账户，您将成为Sisley法国希思黎会员。</p>
          <VForm :model="ValidateForm" :rule="rule" ref="baseForm2">
            <FormItem prop="memberPhone">
              <input
                type="text"
                :class="[
                  registerError ? 'c-input-error' : '',
                  'c-input',
                  'c-input--fullwidth',
                ]"
                @keyup="memberPhoneValid"
                maxlength="11"
                placeholder="手机号码"
                v-model="ValidateForm.memberPhone"
              />
              <div class="error-msg" v-if="registerError">{{ registerMsg }}</div>
            </FormItem>
            <div class="text--right">
              <button
                class="c-button c-button--primary c-button-register"
                :disabled="disabledJoinMember"
                @click="goRegister"
              >成为会员</button>
            </div>
          </VForm>
        </div>
        <template v-if="$store.state.showVisitor">
          <div class="tourist">以游客身份继续</div>
          <div class="privacy-row clickable" @click="isAgree = !isAgree">
              <i class="iconfont">
                {{
                isAgree ? "&#xedaf;" : "&#xec58;"
                }}
              </i>
              <span>
                我已阅读并了解希思黎官网的
                <router-link
                  to="/terms"
                  target="_blank"
                  @click.native.stop
                  rel="nofollow"
                >条款与条件</router-link>
                和
                <router-link
                  to="/privacy"
                  target="_blank"
                  @click.native.stop
                  rel="nofollow"
                >隐私政策</router-link>，并且同意接受其中所有的条款
              </span>
          </div>
          <div class="text--right">
            <button
              class="c-button c-button--primary c-button-register"
              :disabled="!isAgree"
              @click="goVisitor"
            >继续购买</button>
          </div>
        </template>
      </div>
    </div>
    <Forget v-show="showForget" @close="showForget = false" />
  </div>
</template>

<script>
import VForm from "@/components/form/my-form";
import FormItem from "@/components/form/form-item";
import Forget from "@/components/ForgetPassword";
import api from "@/utils/api";
import types from "@/store/types";
import utils from "@/utils/index";
export default {
  components: { VForm, FormItem, Forget },
  data() {
    return {
      showLogin: false,
      showForget: false,
      swiperList: ["手机验证码登录", "密码登录"],
      currentTab: 0,
      captchaImg: "",
      iptType: "password",
      showPicCode: false,
      ValidateForm: {
        account: "",
        password: "",
        phone: "",
        picCode: "",
        phoneCode: "",
        memberPhone: "",
      },
      rule: {
        account: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
        ],
        picCode: [
          { required: true, message: "图形验证码不能为空", trigger: "blur" },
        ],
        phoneCode: [
          { required: true, message: "手机验证码不能为空", trigger: "blur" },
        ],
        memberPhone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
        ],
      },
      userCheck: localStorage.getItem("log_name") || false,
      countdown: 0,
      loginMsg: "",
      registerError: false,
      registerMsg: "",
      loginError: false,
      accountError: false,
      accountMsg: "",
      capthaError: true,
      capthaErrMsg: "",
      codeError: false,
      codeMsg: "",
      phonecodeError: false,
      phonecodeMsg: "",
      passwordError: false,
      passwordMsg: "",
      errMsg: "",
      isAgree: false
    };
  },
  computed: {
    disabledSendSMS() {
      if (this.countdown) return true;
      let hasImgCode = this.showPicCode;
      let { phone, picCode } = this.ValidateForm;
      if (
        (!hasImgCode && /^1[3456789]\d{9}$/.test(phone)) ||
        (hasImgCode && /^1[3456789]\d{9}$/.test(phone) && picCode && !this.capthaError)
      ) {
        return false;
      }
      return true;
    },
    disabledSubmit() {
      let type = this.currentTab;
      let hasImgCode = this.showPicCode;
      let { account, password, phone, picCode, phoneCode } = this.ValidateForm;
      if (type === 1 && account && password) {
        return false;
      } else if (
        type === 0 &&
        ((!hasImgCode && /^1[3456789]\d{9}$/.test(phone) && phoneCode) ||
          (hasImgCode &&
            /^1[3456789]\d{9}$/.test(phone) &&
            picCode &&
            phoneCode))
      ) {
        return false;
      }
      return true;
    },
    disabledJoinMember() {
      let mobile = this.ValidateForm.memberPhone;
      if (/^1[3456789]\d{9}$/.test(mobile)) {
        return false;
      }
      return true;
    },
    isMobile() {
      return utils.isMobile();
    },
  },
  created() {
    if (this.userCheck && localStorage.getItem("mobile")) {
      this.ValidateForm.account = utils.getItem("mobile");
      // this.ValidateForm.phone = utils.getItem("mobile");
    }
  },
  updated() {},
  methods: {
    clearError(errField, errMsgField) {
      this[errField] && (this[errField] = false);
      this[errMsgField] && (this[errMsgField] = "");
    },
    closeLogin() {
      this.$store.commit("toggleLogin", false);
      this.$emit("loginClose");
      this.loginMsg = "";
      this.registerError = false;
      this.registerMsg = "";
      this.loginError = false;
      this.accountError = false;
      this.accountMsg = "";
      this.capthaError = false;
      this.capthaErrMsg = "";
      this.codeError = false;
      this.codeMsg = "";
      this.phonecodeError = false;
      this.phonecodeMsg = "";
      this.passwordError = false;
      this.passwordMsg = "";
      this.errMsg = "";
    },
    tapNav(idx) {
      this.currentTab = idx;
      // this.showPicCode=false;
      this.loginMsg = "";
      this.loginError = false;
      this.$refs["baseForm"].resetFields();
    },
    getCaptcha() {
      api[types.GET_CAPTCHA]()
        .then((res) => {
          this.captchaImg = res.data.img;
          this.captchaId = res.data.key;
        })
        .catch();
    },
    checkCaptha() {
      let _data = {
        valid_id: this.captchaId,
        valid_code: this.ValidateForm.picCode,
      };
      api[types.CHECK_CAPTCHA](_data)
        .then((res) => {
          if (res.code == 1) {
            this.capthaError = false;
            this.capthaErrMsg = "";
          } else {
            this.capthaError = true;
            this.capthaErrMsg = res.message;
          }
        })
        .catch();
    },
    sendMsg() {
      let { phone, picCode } = this.ValidateForm;
      let newArgs = { phone, type: 1 };
      if (this.showPicCode) {
        newArgs.valid_id = this.captchaId;
        newArgs.valid_code = picCode;
      }
      if (phone) {
        api[types.SEND_MSG](newArgs).then((res) => {
          if (res.code == 1) {
            this.runCountdown(60, (time) => {
              this.countdown = time;
            });
          } else {
            switch (res.data.field) {
              case "valid_code":
                this.codeError = true;
                this.codeMsg = res.message;
                break;
              case "password":
                this.passwordError = true;
                this.passwordMsg = res.message;
                break;
              case "msg_code":
                this.phonecodeError = true;
                this.phonecodeMsg = res.message;
                break;
              case "account":
                this.accountError = true;
                this.accountMsg = res.message;
                break;
              default:
                this.loginError = true;
                this.errMsg = res.message;
                // this.$alert({title:'提示',message:res.message});
                break;
            }
            if (res.data.fail_mark == 1) {
              this.showPicCode = true;
              this.getCaptcha();
            }
          }
        }).catch();
      }
    },
    runCountdown(times, callback) {
      if (isNaN(times)) callback("倒计时定时器时间设置错误");
      callback(times);
      let timer = setInterval(() => {
        --times;
        callback(times, timer);
        if (times == 0) clearInterval(timer);
      }, 1000);
    },
    // 切换密码输入框类型
    toggleIptType() {
      this.iptType = this.iptType == "password" ? "text" : "password";
    },
    submit() {
      // 调用form组件的validate方法
      this.$refs.baseForm
        .validate()
        .then((res) => {
          if (res) {
            let _data;
            if (this.currentTab == 0) {
              _data = {
                phone: this.ValidateForm.phone,
                msg_code: this.ValidateForm.phoneCode,
              };
            } else {
              _data = {
                account: this.ValidateForm.account,
                password: utils.encrypt(this.ValidateForm.password),
                // password: this.ValidateForm.password,
              };
            }
            if (this.showPicCode) {
              _data.valid_id = this.captchaId;
              _data.valid_code = this.ValidateForm.picCode;
            }
            api[types.USER_LOGIN](_data)
              .then((res) => {
                if (res?.code == 1) {
                  // 登录成功后清空数据&状态
                  this.showPicCode = false;
                  this.closeLogin();
                  if (res.data.is_complete == 1) {
                    utils.setItem("saveTmepUser", res.data);
                    // this.$store.commit('saveTmepUser', res.data);
                    this.$router.push({
                      name: "Complete",
                    });
                  } else {
                    let returnUrl = decodeURIComponent(this.$route.query.returnUrl || "/");
                    let isCheckout = returnUrl.indexOf("checkout") != -1;
                    this.$store.commit(types.USER_LOGIN, res);
                    this.$store.dispatch(types.GET_PROFILE);
                    this.$store.dispatch(types.CART_GET, () => {
                      isCheckout && this.$router.push({ path: returnUrl });
                    });
                    this.$store.dispatch(types.FAV_PIDS_LIST);
                    this.$emit("loginSuccess");
                    !isCheckout && this.$router.push({ path: returnUrl });
                    if (this.userCheck) {
                      utils.setItem("log_name", true);
                      utils.setItem("mobile", _data.account || _data.phone);
                    } else {
                      utils.removeItem("log_name");
                      utils.removeItem("mobile");
                    }
                  }
                  // 
                  utils.bdTracker('login_success');
                } else {
                  if (res.data.field) {
                    switch (res.data.field) {
                      case "valid_code":
                        this.codeError = true;
                        this.codeMsg = res.message;
                        break;
                      case "password":
                        this.passwordError = true;
                        this.passwordMsg = res.message;
                        break;
                      case "msg_code":
                        this.phonecodeError = true;
                        this.phonecodeMsg = res.message;
                        break;
                      case "account":
                        this.accountError = true;
                        this.accountMsg = res.message;
                        break;
                      default:
                        this.loginError = true;
                        this.errMsg = res.message;
                        // this.$alert({title:'提示',message:res.message});
                        break;
                    }
                  }
                  if (res.data.fail_mark == 1) {
                    this.showPicCode = true;
                    this.getCaptcha();
                  }
                }
              })
              .catch((err) => {
                console.warn(err);
              });
            // 
            utils.bdTracker('login');
          }
        })
        .catch((e) => {
          console.warn(e);
        });
    },
    goRegister() {
      this.$refs.baseForm2.validate().then((res) => {
        if (res) {
          api[types.USER_EXIST]({ phone: this.ValidateForm.memberPhone })
            .then((res) => {
              if (res.code == 1) {
                this.closeLogin();
                let newQuery = {
                  phone: this.ValidateForm.memberPhone,
                };
                let returnUrl = this.$route.query.returnUrl;
                if (returnUrl) newQuery.returnUrl = returnUrl;
                this.$router.push({
                  name: "Register",
                  query: newQuery,
                });
              } else {
                this.registerMsg = res.message;
                this.registerError = true;
                // this.$toast({ message: res.message, iconCls: "failure" });
              }
            })
            .catch((err) => {
              console.warn(err);
            });
          // 
          utils.bdTracker('register');
        }
      });
    },
    // 联合登陆
    toThridLogin(channel) {
      let returnUrl = decodeURIComponent(this.returnUrl || this.$route.query?.returnUrl || "/");
      if (channel == "wechat" || channel == "alipay") {
        location.href = `${api.API_PATH}member/get/socialite/${channel}?returnUrl=${returnUrl}`;
      } else {
        console.warn(`未知第三方登录渠道：${channel}`);
      }
    },
    // 限制手机号只能输入数字
    memberPhoneValid(e){
      this.ValidateForm.memberPhone = e.target.value.replace(/[^\d]/g,'');
    },
    goVisitor() {
      this.$store.commit("toggleLogin", false);
      this.$router.push({ name:'Checkout' });
    }
  },
};
</script>

<style lang="scss" scoped>
.union-login {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.union-login__hits {
  font-size: 0.75rem;
}
.login-icon {
  margin-left: 0.5rem;
  font-size: 20px;
  line-height: 2.75rem;
  cursor: pointer;
}
.login-btn {
  .c-button-login {
    padding: 0.8125rem 1.25rem;
  }
}
.l-login-popin {
  position: fixed;
  right: -100%;
  top: 0;
  opacity: 0;
  background-color: #fff;
  height: 100%;
  z-index: 12;
  // max-width: 23.3125rem;
  width: 100%;
  transition-property: opacity, right;
  transition-duration: 1.5s, 1s;
  &.in {
    position: fixed;
    right: 0;
    opacity: 1;
    transition-property: opacity, right;
    transition-duration: 2s, 1.5s;
  }
  .l-login-popin-container {
    overflow-y: auto;
    height: 100%;
    padding: 2.3125rem 1rem;
    .l-login-popin__item-separator {
      padding-bottom: 1.125rem;
      width: 100%;
      .c-form__heading {
        font-weight: 700;
      }
    }
    .l-login-popin__heading {
      margin-top: 1.625rem;
    }
    h2 {
      margin-bottom: 2.5rem;
    }
    .l-login-popin__text {
      margin-bottom: 1.875rem;
    }
    .swiper-tab {
      display: flex;
      color: #5e5e5e;
      align-items: center;
      margin-bottom: 30px;
      .active {
        color: #282828;
        border-bottom: 2px solid #282828;
      }
      .swiper-tab-list {
        height: 100%;
        text-align: center;
        cursor: pointer;
        &:first-child {
          margin-right: 3rem;
        }
      }
    }
    .form-group {
      .sr-only {
        border: 0 !important;
        clip: rect(1px, 1px, 1px, 1px) !important;
        -webkit-clip-path: inset(50%) !important;
        clip-path: inset(50%) !important;
        height: 1px !important;
        overflow: hidden !important;
        padding: 0 !important;
        position: absolute !important;
        width: 1px !important;
        white-space: nowrap !important;
      }
      .c-input {
        &.is-invalid {
          border-color: #c53131;
        }
      }
      .invalid-feedback {
        position: absolute;
        // bottom: 86%;
        top: -0.575rem;
        left: 1.5625rem;
        background-color: #fff;
        padding: 0 0.5625rem;
        margin-bottom: 0;
        color: #c53131;
        font-size: 0.6875rem;
      }
      .custom-checkbox {
        display: flex;
        align-items: center;
        position: relative;
        margin-left: 1.375rem;
        .clickable {
          line-height: 1.5625rem;
          .iconfont {
            margin-right: 0.75rem;
            line-height: 1.5625rem;
          }
        }
      }
      .custom-control-input {
        position: absolute;
        opacity: 0;
        top: auto;
        overflow: hidden;
        clip: rect(1px, 1px, 1px, 1px);
        width: 0.0625rem;
        height: 0.0625rem;
        white-space: nowrap;
        display: block;
      }
      .custom-checkbox [type="checkbox"] {
        position: absolute;
        top: auto;
        overflow: hidden;
        clip: rect(1px, 1px, 1px, 1px);
        width: 0.0625rem;
        height: 0.0625rem;
        white-space: nowrap;
        display: block;
      }
      .reset-password {
        font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
        text-decoration: underline;
        line-height: 1.5625rem;
      }
    }
    .heading-h5 {
      font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif;
      font-weight: 400;
      font-style: normal;
      line-height: 1.66;
    }
    .c-form-explanation {
      font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
      font-size: 0.6875rem;
      font-weight: 300;
      padding: 0.875rem 1.25rem 0.8125rem;
    }
  }
  .float-center {
    display: block;
    margin-right: auto;
    margin-left: auto;
    .l-login-popin__close-button {
      display: inline-block;
    }
  }
  .c-input-error {
    border: 1px solid #df4c4c;
    background: #ffeaea;
  }
  .error-msg {
    color: #df4c4c;
    padding: 0.175rem 1rem 0;
  }
}

.tourist {
  font-size: 12px;
  margin-bottom: 14px;
  padding-top: 22px;
}

.privacy-row {
  font-size: 12px;
  padding-bottom: 24px;
}
@media screen and (min-width: 48em) {
  .login-btn {
    .c-button-login {
      padding: 0.8125rem 1.875rem;
    }
  }
  .l-login-popin {
    max-width: 26.75rem;
    .l-login-popin-container {
      padding: 2.3125rem 3.125rem;
      .c-button {
        font-size: 0.75rem;
        padding: 0.9375rem 1.875rem;
      }
      .c-button--rounded {
        padding: 0;
      }
      .c-button--primary {
        font-size: 0.75rem;
        padding: 0.9375rem 1.875rem;
      }
    }
  }
}
@media screen and (min-width: 64em) {
  .l-login-popin {
    max-width: 35.6875rem;
    min-width: 26.75rem;
    .l-login-popin-container {
      padding: 6.25rem 5rem 6.25rem 6.25rem;
    }
  }
}
@media screen and (min-width: 75em) {
}
</style>